import { isNumber, isFinite } from 'lodash';
export var isPixelValue = function (value) { return /(px)/.test(value); };
export var isPercentageValue = function (value) { return /%/i.test(value); };
export var isNumeric = function (value) {
    var parsedValue = parseFloat(value);
    if ("" + parsedValue !== "" + value) {
        return false;
    }
    return isNumber(parsedValue) && isFinite(parsedValue);
};
export var isNumericValueWithUnits = function (value) {
    return "" + parseFloat(value) !== "" + value;
};
var lowerCaseString = function (value) {
    return typeof value === 'string' ? value.toLowerCase() : value;
};
export var getPxValue = function (value) {
    if ([isPixelValue, isPercentageValue, isNumeric].some(function (validator) {
        return validator(lowerCaseString(value));
    })) {
        return ("" + value + (isNumericValueWithUnits(value) ? '' : 'px'))
            .toLowerCase()
            .replace(/\s+/g, '');
    }
    else {
        throw new Error("Trying to get pixel value for invalid value '" + value + "'");
    }
};
//# sourceMappingURL=line-height-to-px.js.map